export const UPLOAD_SUPPORT_MEDIA_FILE_EXTENSION = [
  // audio
  'mp3',
  'wav',
  'aac',
  'flac',
  'ogg',
  'm4a',
  'wma',
  'alac',
  'aiff',
  // video
  'mp4',
  'avi',
  'mov',
  'wmv',
  'mkv',
  'flv',
  'mpeg',
  'mpg',
  'webm',
  '3pg',
];
